import { Folder } from 'lucide-react';
import { CreateProjectButton } from 'widgets/project-creation-stepper';
import type { CreateProjectButtonProps } from 'widgets/project-creation-stepper/ui/create-project-button';
import * as m from '@paraglide/messages';
export const FirstProject = ({
  ...props
}: CreateProjectButtonProps) => {
  return <div className="mx-auto mt-20 max-w-xl rounded-lg bg-accent px-[70px] pb-9 pt-20" data-sentry-component="FirstProject" data-sentry-source-file="first-project.tsx">
      <div className="flex flex-col items-center justify-center text-center">
        <Folder size={24} className="mb-4" data-sentry-element="Folder" data-sentry-source-file="first-project.tsx" />
        <div className="flex flex-col items-center justify-center space-y-8">
          <h1 className="text-title2 font-light">
            {m.projectCreation_firstProject_title()}
          </h1>
          <CreateProjectButton {...props} data-sentry-element="CreateProjectButton" data-sentry-source-file="first-project.tsx" />
          <div className="mt-4 max-w-md rounded-lg text-body3 text-zinc-300">
            <p className="mb-4 text-body3 ">
              {m.projectCreation_firstProject_free()}
            </p>
            <p className="text-body3">
              {m.projectCreation_firstProject_free_desc()}
            </p>
          </div>
        </div>
      </div>
    </div>;
};